import { OrderingProviderDto } from 'src/app/models';
import { OrderStepResolverAction } from '../../../../models/order-step-resolver-action.model';
import { OrderInfoModel } from '../../models/order-info.model';

export class InitOrderInfoStep implements OrderStepResolverAction {
  public static readonly type = '[OrderInfoStep] Init Order Info Step';
}

export class UpdateOrderInfoStep {
  public static readonly type = '[OrderInfoStep] Update Order Info Step';
}

export class SaveOrderInfoStep {
  public static readonly type = '[OrderInfoStep] Save Order Info Step';

  constructor(public readonly orderInfoModel: OrderInfoModel) {}
}

export class UpdateOrderingProvider {
  public static readonly type = '[OrderInfoStep] Update Ordering Provider';

  constructor(public readonly orderingProviderDto: OrderingProviderDto | null) {}
}

export class UpdateCopyToProvider {
  public static readonly type = '[OrderInfoStep] Update Copy To Provider';

  constructor(
    public readonly copyToProviderDto: OrderingProviderDto | null,
    public readonly isCreatingNew = false,
    // Order-level Reports Via; when omitted the provider's own value is used.
    public readonly sendVia: string | null = null
  ) {}
}

export class CancelEditCopyToProvider {
  public static readonly type = '[OrderInfoStep] Cancel Edit Copy To Provider';
}

export class EditCopyToProvider {
  public static readonly type = '[OrderInfoStep] Edit Copy To Provider';
}

export class LabSelectionChanged {
  public static readonly type = '[OrderInfoStep] Lab Selection Changed';
}
